import { PublicKey } from '@solana/web3.js';
import { Opaque } from '@drift/common';
import { PerformanceDataSet, PnlTimePeriodOption } from './performance';

export * from './trade';

export type ComputeUnits = Opaque<'ComputeUnits', number>;
export type PriorityFee = Opaque<'PriorityFee', number>;

export const DEFAULT_PUBLIC_KEY = new PublicKey(
	'11111111111111111111111111111111'
);

export const PERFORMANCE_TIMEFRAMES: PnlTimePeriodOption[] = [
	'24h',
	'7d',
	'30d',
	'all',
];

export const DEFAULT_PERFORMANCE_DATA: PerformanceDataSet = {
	'24h': [],
	'7d': [],
	'30d': [],
	all: [],
};

export type DailyAllTimePnlSnapshot = {
	epochTs: number;
	totalAccountValue: number;
	allTimeTotalPnl: number;
	allTimeTotalPnlPct: number;
};

export type MarketTypeFilter = 'perp' | 'spot' | 'prediction';

export type SimpleFundingRateRecord = {
	marketIndex: number;
	ts: number;
	fundingRate: number;
	marketPrice: number;
	isAsymmetric: boolean;
	fundingRateLong?: number;
	fundingRateShort?: number;
};

export type SlippageTolerance = number | 'dynamic';

export type BalanceDisplayType = 'base' | 'notional';
